/*
 * @Description: 注册公用组件
 * @Author: lz
 * @Date: 2021-07-20 15:17:21
 * @LastEditTime: 2021-07-21 16:36:47
 * @LastEditors: lz
 */
export default {
  install(Vue) {
    // 批量注册公用组件
    const components = require.context('@/components/common', false, /\.vue$/)
    components.keys().map((path) => {
      const fileName = path.replace(/(.*\/)*([^.]+).*/gi, '$2') // 获取组件文件名
      Vue.component(fileName, components(path).default || components(path))
    })
  }
}
